import { Divider, Empty, Row, Col, Button } from "antd";
import { useMovimentacaoTituloListar } from "@/Services/Financeiro/Conta/MovimentacaoService";
import MovimentacaoTableBasic, { IMovimentacaoTableBasicProps } from "@/Components/Populados/Financeiro/Conta/Movimentacao/MovimentacaoTableBasic";
import ComponentePermissao, { usePermitido } from "@/Components/Base/Permissao/ComponentePermissao";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
import { Link, useParams } from "react-router-dom";

interface ITituloMovimentacaoConsultaScreen extends IMovimentacaoTableBasicProps {
    codTitulo?:number;
}

export default function TituloMovimentacaoConsultaScreen({
    codTitulo : codTituloParam,
    loading,
    ...props
}:ITituloMovimentacaoConsultaScreen) {
    const { codigo : codTituloRota } = useParams();

    const codTitulo = (codTituloParam === undefined || isNaN(codTituloParam) ? Number.parseInt(codTituloRota ?? '-1') : codTituloParam) ?? -1

    const {
        permitido
    } = usePermitido({
        permissoes : ["FinanceiroContaMovimentacaoListarPorTitulo"]
    });

    const {
        data,
        isLoading,
        isSuccess,
        isError
    } = useMovimentacaoTituloListar({
        codTitulo : codTitulo,
        enabled : permitido && codTitulo > 0
    });

    return <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarPorTitulo"]}>
        <Row gutter={8} wrap>
            <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoInserir"]}>
                <Col xs={"auto"}>
                    <Link to={`./Movimentacao/Novo`}>
                        <Button type="primary">Adicionar</Button>
                    </Link>
                </Col>
            </ComponentePermissao>
        </Row>
        {
            (isSuccess || isLoading) && <TelaCarregamento ativo={isLoading}>
                <Divider>Registros</Divider>
                <MovimentacaoTableBasic {...props} dataSource={data} pathBaseLink="./Movimentacao/"/>
            </TelaCarregamento> || <>
                <Empty description={isError ? "Ocorreu um erro, tente novamente!" : "Clique em \"Listar\" para realizar a consulta."} />
            </>
        }
    </ComponentePermissao>;
}